import axios from "./axios";
import { api } from "./axios.config";


const API_URL = axios.defaults.baseURL;
const BASE_URL = "/event/";
const TICKET_REGENERATION_ENDPOINT = "/ticket/regeneration";



export const retrieveTicketRegeneration = eventId => {
    return axios.post(API_URL + BASE_URL + eventId + TICKET_REGENERATION_ENDPOINT);
};

export const fetchTicketRegeneration = eventId => {
    return axios.get(API_URL + BASE_URL + eventId + TICKET_REGENERATION_ENDPOINT);
};